import React from 'react'
import Page from '../Page/Page'
import TitleToolbar from '../Page/TitleToolbar'
import PageContent from '../Page/PageContent'
import FormatSelectorContainer from './FormatSelectorContainer'
import ExportButtonContainer from './ExportButtonContainer'
import FieldCheckboxSetContainer from './FieldCheckboxSetContainer'
import SridSelectorContainer from '../Filter/SridSelectorContainer'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
	div: {
		marginBottom: theme.spacing.unit * 2
	}
})

const ExportPage = ({ classes }) => (
	<Page>
		<TitleToolbar title="Exportera" />
		<PageContent padding>
			<form>
				<div className={classes.div}>
					<Typography variant="caption">Format</Typography>
					<FormatSelectorContainer />
				</div>
				<FieldCheckboxSetContainer />
				<div className={classes.div}>
					<Typography variant="caption">Koordinatsystem</Typography>
					<SridSelectorContainer />
				</div>
				<Typography variant="body1" className={classes.div}>
					Observera att osäkerheten för höjder i RH 00 och RH 70 varierar mellan mm- och dm-nivå oavsett antal decimaler som visas.
				</Typography>
				<ExportButtonContainer />
	      	</form>
      	</PageContent>
   </Page>
)

export default withStyles(styles)(ExportPage)



// WEBPACK FOOTER //
// ./src/components/Export/ExportPage.js